// ✅ src/redux/slices/updateLoanSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;

// 🔹 Fetch Loan by ID
export const fetchLoanById = createAsyncThunk(
  'updateLoan/fetchLoanById',
  async (loanId, { rejectWithValue }) => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) return rejectWithValue('Authorization token is missing.');

      const response = await axios.get(`${BASE_URL}/get-loan-by/${loanId}`, {
        headers: { Authorization: `Bearer ${authToken}` },
      });

      if (!response.data) {
        throw new Error('Loan data not found');
      }

      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Failed to load loan data';
      return rejectWithValue(message);
    }
  }
);

// 🔹 Update Loan by ID
export const updateLoanById = createAsyncThunk(
  'updateLoan/updateLoanById',
  async ({ loanId, loanData }, { rejectWithValue }) => {
    try {
      const authToken = localStorage.getItem('authToken');
      if (!authToken) return rejectWithValue('Authorization token is missing.');

      const response = await axios.put(`${BASE_URL}/update-loan/${loanId}`, loanData, {
        headers: { Authorization: `Bearer ${authToken}` },
      });

      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || error.message || 'Loan update failed';
      return rejectWithValue(message);
    }
  }
);

const initialState = {
  loan: null,
  loading: false,
  success: false,
  error: null,
};

const updateLoanSlice = createSlice({
  name: 'updateLoan',
  initialState,
  reducers: {
    resetUpdateLoanState(state) {
      state.loan = null;
      state.loading = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoanById.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.loan = null;
      })
      .addCase(fetchLoanById.fulfilled, (state, action) => {
        state.loading = false;
        state.loan = action.payload;
      })
      .addCase(fetchLoanById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateLoanById.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateLoanById.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(updateLoanById.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateLoanState } = updateLoanSlice.actions;
export default updateLoanSlice.reducer;
